import React, { useEffect, useState, useRef } from "react";
import "./racing.css";
import { socket } from "../../io";
import { heightCanvas, widthCanvas } from "../../utils/const";
import {
  Stage,
  Layer,
  Image as KonvaImage,
  Rect,
  Group,
  Text,
} from "react-konva";
import logo from "../../assets/logo.png";

const Racing = (props) => {
  const [showMsn, setShowMsn] = useState(false);
  const [videoSrc, setVideoSrc] = useState("");
  const [startup] = useState(new Date().getTime());
  const [imgLogo, setImgLogo] = useState();

  const videoRef = useRef(null);
  const konvaImageRef = useRef(null);
  const rafRef = useRef(null);

  const currentVideoSrcRef = useRef("");
  const videoFinishedRef = useRef(false);

  useEffect(() => {
    const handleResize = () => {
      window.location.reload();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const img = new window.Image();
    img.src = logo;
    img.onload = () => setImgLogo(img);
  }, []);

  const stopAnimationLoop = () => {
    if (rafRef.current) {
      cancelAnimationFrame(rafRef.current);
      rafRef.current = null;
    }
  };

  useEffect(() => {
    if (!videoSrc) return;

    stopAnimationLoop();

    const videoElement = document.createElement("video");

    videoElement.src = videoSrc;
    videoElement.muted = true;
    videoElement.playsInline = true;
    videoElement.preload = "auto";

    videoRef.current = videoElement;
    currentVideoSrcRef.current = videoSrc;
    videoFinishedRef.current = false;

    const drawFrame = () => {
      const imageNode = konvaImageRef.current;

      if (!imageNode) return;

      imageNode.getLayer()?.batchDraw();
    };

    const animate = () => {
      if (!videoRef.current) return;

      drawFrame();

      if (!videoRef.current.paused && !videoRef.current.ended) {
        rafRef.current = requestAnimationFrame(animate);
      }
    };

    const handleLoadedData = async () => {
      const imageNode = konvaImageRef.current;

      if (!imageNode) return;

      imageNode.image(videoElement);
      drawFrame();

      try {
        videoElement.currentTime = 0;
        await videoElement.play();
      } catch (error) {
        console.error("No se pudo reproducir el video:", error);
      }
    };

    const handlePlay = () => {
      stopAnimationLoop();
      rafRef.current = requestAnimationFrame(animate);
    };

    const handleEnded = () => {
      videoFinishedRef.current = true;

      stopAnimationLoop();

      /*
        IMPORTANTE:
        Cuando el video termina, algunos navegadores limpian visualmente
        el último frame si no lo dejamos en una posición válida.
        Por eso regresamos una fracción mínima antes del final.
      */
      try {
        if (videoElement.duration && Number.isFinite(videoElement.duration)) {
          videoElement.currentTime = Math.max(videoElement.duration - 0.05, 0);
        }
      } catch (error) {
        console.warn("No se pudo fijar el último frame:", error);
      }

      videoElement.pause();

      setTimeout(() => {
        drawFrame();
      }, 80);
    };

    videoElement.addEventListener("loadeddata", handleLoadedData);
    videoElement.addEventListener("play", handlePlay);
    videoElement.addEventListener("ended", handleEnded);

    return () => {
      stopAnimationLoop();

      videoElement.removeEventListener("loadeddata", handleLoadedData);
      videoElement.removeEventListener("play", handlePlay);
      videoElement.removeEventListener("ended", handleEnded);

      videoElement.pause();
      videoElement.src = "";
      videoElement.load();
    };
  }, [videoSrc]);

  useEffect(() => {
    const handleVideo = (data) => {
      const nextVideoSrc = `../../videos/${data.video}`;

      if (new Date().getTime() - startup > 10000) {
        setShowMsn(true);
      }

      /*
        Si llega el mismo video y ya terminó,
        NO se vuelve a reproducir.
      */
      if (
        currentVideoSrcRef.current === nextVideoSrc &&
        videoFinishedRef.current
      ) {
        return;
      }

      /*
        Si llega el mismo video mientras está cargado,
        tampoco lo reiniciamos.
      */
      if (currentVideoSrcRef.current === nextVideoSrc) {
        return;
      }

      setShowMsn(false);
      setVideoSrc(nextVideoSrc);
    };

    socket.on("video", handleVideo);

    return () => {
      socket.off("video", handleVideo);
    };
  }, [startup]);

  return (
    <Stage width={widthCanvas} height={heightCanvas}>
      <Layer>
        {!showMsn || (videoSrc !== "" && !videoSrc.includes("x")) ? (
          <Group x={0} y={0} width={widthCanvas} height={heightCanvas}>
            <KonvaImage
              ref={konvaImageRef}
              x={0}
              y={0}
              width={widthCanvas}
              height={heightCanvas}
            />

            <KonvaImage
              image={imgLogo}
              x={widthCanvas * 0.8}
              y={0}
              width={widthCanvas * 0.15}
              height={heightCanvas * 0.07}
              visible={true}
            />
          </Group>
        ) : (
          <Group
            x={widthCanvas / 4}
            y={heightCanvas / 4}
            fill="blue"
            width={widthCanvas / 2}
            height={heightCanvas / 2}
          >
            <Rect
              x={0}
              y={0}
              fill="blue"
              width={widthCanvas / 2}
              height={heightCanvas / 2}
              cornerRadius={10}
              stroke="red"
              strokeWidth={10}
            />

            <Text
              text="NOTICE/AVISO"
              x={0}
              y={0}
              fill="white"
              width={widthCanvas / 2}
              height={heightCanvas / 6}
              align="center"
              verticalAlign="middle"
              fontSize={heightCanvas * 0.1}
              fontFamily="Arial Dark"
            />

            <Text
              text="Error in transmission, the race is active..."
              x={0}
              y={heightCanvas / 8}
              fill="white"
              width={widthCanvas / 2}
              height={heightCanvas / 6}
              align="center"
              verticalAlign="middle"
              fontSize={heightCanvas * 0.05}
              fontFamily="Arial Dark"
            />

            <Text
              text="Error en transmisión, la carrera está activa..."
              x={0}
              y={heightCanvas / 4}
              fill="white"
              width={widthCanvas / 2}
              height={heightCanvas / 6}
              align="center"
              verticalAlign="middle"
              fontSize={heightCanvas * 0.05}
              fontFamily="Arial Dark"
            />
          </Group>
        )}
      </Layer>
    </Stage>
  );
};

export default Racing;